import React from "react";

import Promo from "../../components/promo/Promo";
import Team from "../../components/team/Team";

function Home(){
    return(
        <div className="App">
            <Promo/>
            <Team/>
        </div>
    )
}

export default Home;
